export const sortFilterCategories = (a: string, b: string) => {
  const categoriesOrder = ['AKTIE', 'ETF', 'FONDS', 'DERIVAT', 'KRYPTO'];
  const aIndex = categoriesOrder.indexOf(a);
  const bIndex = categoriesOrder.indexOf(b);
  return aIndex - bIndex;
};
